<template>
    <div>
        <el-form :inline="true" :model="formInline" class="demo-form-inline select-wrap" :size="GCONFIG.styleElFormSize">
            <el-form-item>
                <el-button type="text" icon="el-icon-arrow-left" @click="returnHistory">返回</el-button>
            </el-form-item>
            <el-form-item label="所属组" v-show="groupData.length>0">
                <el-select v-model="formInline.tagGroupId" clearable filterable placeholder="所属组" >
                    <el-option v-for="item in groupData"
                               :key="item.id"
                               :label="item.groupName"
                               :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
        <el-form-item>
            <el-button-group style="margin: 5px 0">
                <el-button type="primary" @click="getList">查询</el-button>
                <el-button type="success" @click="handleAdd">新增</el-button>
                <el-button type="primary" v-show="false" @click="pullTag">同步标签</el-button>
            </el-button-group>
        </el-form-item>
        </el-form>

        <div class="content-wrap">
            <el-table :data="listData" stripe border center :size="GCONFIG.styleTableSize" v-loading="loading" >
                <el-table-column type="index" label="序号" width="50"></el-table-column>
                <el-table-column prop="tagGroupName" label="分组名称"  width="120"></el-table-column>
                <el-table-column prop="name" label="标签名称" width="120"></el-table-column>
                <el-table-column prop="sort" label="排序" width="120"></el-table-column>
                <el-table-column prop="createTime"  label="创建时间" ></el-table-column>
                <el-table-column prop="statusName"  label="状态名称" ></el-table-column>
                <el-table-column prop="userNum" label="客户数" width="150" ></el-table-column>
                <el-table-column label="操作" fixed="right" width="300">
                    <template slot-scope="scope">
                        <el-button-group style="margin: 5px 0">
                            <el-button type="danger"  size="mini" @click="handDelete(scope.row)">删除</el-button>
                            <el-button type="primary"  size="mini" @click="handleEdit(scope.row)">修改</el-button>
                            <el-button type="success"  size="mini" @click="handGetRuleGroup(scope.row)">查看规则组</el-button>
                        </el-button-group>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination-wrap">
                <el-pagination
                        background
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="formInline.currentPage"
                        :page-sizes="GCONFIG.pageSizes"
                        :page-size="formInline.pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="formInline.recordsTotal">
                </el-pagination>
            </div>
        </div>

        <el-dialog title="标签规则组逻辑关系" :visible.sync="dialogFormRuleGrouVisible" center>
            <el-form :model="tagData" label-width="120px">
                <el-form-item label="标签规则组间有关系" >
                    <el-select v-model="tagData.conditionType"  clearable filterable placeholder="规则组逻辑关系" >
                        <el-option v-for="itemD in conditionTypeData"
                                   :key="itemD.id"
                                   :label="itemD.name"
                                   :value="itemD.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="标签类型" >
                    <el-select v-model="tagData.tagType"  clearable filterable placeholder="标签类型" >
                        <el-option v-for="item in tagTypeList"
                                   :key="item.id"
                                   :label="item.name"
                                   :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button-group style="margin: 5px 0">
                        <el-button @click="dialogFormRuleGrouVisible = false"  size="mini">取 消</el-button>
                        <el-button type="primary" size="mini" @click="saveTagItemCondition">确 定</el-button>
                    </el-button-group>
                </el-form-item>
            </el-form>
        </el-dialog>

        <el-dialog title="新增" :visible.sync="dialogFormVisible" center>
            <el-form :model="form" label-width="120px">
                <el-form-item label="id" :hidden="true">
                    <el-input v-model=form.id ></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button-group>
                        <el-tooltip class="item" effect="dark" content="点击添加新的标签组" placement="top-start">
                            <el-button @click="showAddGroup=true" type="primary" v-show="!showAddGroup"  size="mini">添加新标签组</el-button>
                        </el-tooltip>
                        <el-tooltip class="item" effect="dark" content="选择已有标签组" placement="top-start">
                            <el-button @click="showAddGroup=false" v-show="showAddGroup" type="primary"  size="mini">选择标签组</el-button>
                        </el-tooltip>
                        <el-tooltip class="item" effect="dark" content="再加一个新标签" placement="top-start">
                            <el-button @click="addOne" type="success"  size="mini">添加新标签</el-button>
                        </el-tooltip>
                    </el-button-group>
                </el-form-item>
                <el-form-item label="选择标签组" required="true" v-show="!showAddGroup" >
                    <el-select v-model="form.group_id" @change="onGroupChange" clearable filterable placeholder="所属组" >
                        <el-option v-for="item in groupData"
                                   :key="item.wxGroupId"
                                   :label="item.groupName"
                                   :value="item.wxGroupId">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="组名称" required="true" v-show="showAddGroup">
                    <el-input type="text" v-model=form.group_name clearable  placeholder="组名称" maxlength="30"
                              show-word-limit></el-input>
                </el-form-item>
                <el-form-item label="组排序" required="true" v-show="showAddGroup">
                    <el-input-number v-model=form.sort clearable  placeholder="排序" :min="0" :max="99999" :step="1"
                                     show-word-limit></el-input-number>
                </el-form-item>
                <el-form-item   v-for="(item,index) in form.tag"
                                required="true"
                                :label="'标签名称'"
                >
                    <el-input type="text" v-model=item.name clearable  placeholder="标签名称" maxlength="30"
                              show-word-limit></el-input>
                </el-form-item>
                <el-form-item   v-for="(item,index) in form.tag"
                                required="true"
                                :label="'标签排序'"
                >
                    <el-input-number v-model=item.sort clearable  placeholder="排序" :min="0" :max="99999" :step="1"
                              show-word-limit></el-input-number>
                </el-form-item>
                <el-form-item   v-for="(item,index) in form.tag"
                                required="true"
                                :label="'规则组逻辑关系'"
                >
                    <el-select v-model="item.conditionType"  clearable filterable placeholder="规则组逻辑关系" >
                        <el-option v-for="itemD in conditionTypeData"
                                   :key="itemD.id"
                                   :label="itemD.name"
                                   :value="itemD.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button-group style="margin: 5px 0">
                        <el-button @click="dialogFormVisible = false"  size="mini">取 消</el-button>
                        <el-button type="primary" size="mini" @click="save(form)">确 定</el-button>
                    </el-button-group>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
    //导入 HTTP请求方法
    import {getTagList,getTagCustomerList,saveTag,deleteTag,getTagGroupList,pullTag,saveTagItem} from '../../api/api';
    //定义组件
    export default{
        data(){
            return {
                listData:[],
                groupData:[],
                showAddGroup:false,
                statusData:[{"id":0,"name":"否"},{"id":1,"name":"是"}],
                conditionTypeData:[{"id":1,"name":"且"},{"id":2,"name":"或"}],
                tagTypeList:[{"id":1,"name":"事实标签"},{"id":2,"name":"模型标签"}],
                loading:true,
                dialogFormVisible:false,
                dialogFormRuleGrouVisible:false,
                tagData:{},
                form:{"id": null,
                    "group_id": "",
                    "group_name": "",
                    "sort":0,
                    "tag":[]
                   },
                formInline:{
                    currentPage: 1,
                    pageSize: 15,
                    recordsTotal: 0,
                    tagGroupId:null,
                },
            }
        },
        //挂载时候执行
        mounted(){
            this.getGroupList();
            this.getList();
        },
        components:{

        },
        methods:{
            //定义查询方法
            getList(){
                this.loading=true
                getTagList(this.formInline).then((res) => {
                    this.loading = false;
                    this.formInline.recordsTotal = res.data.value.total;
                    this.listData = res.data.value.list;
                })
            },
            editTagRuleGroup(row){

            },
            handGetRuleGroup(row){
                this.$router.push({
                    path: '/corpTagRuleGroup',
                    query: {
                        tagId: row.id,
                        tagName:row.name
                    }
                })
            },
            pullTag(){
                this.loading=true
                pullTag().then((res) => {
                    if(res.data.success){
                        this.getList(this.currentPage, this.pageSize);
                    }else{
                        this.$message({
                            message:res.data.message,
                            type:'error'
                        });
                    }
                })
            },
            getGroupList(){
                getTagGroupList({currentPage:1,pageSize:3000}).then((res) => {
                    this.loading = false;
                    this.formInline.recordsTotal = res.data.value.total;
                    this.groupData = res.data.value.list;
                })
            },
            handleSizeChange(val) {
                this.formInline.pageSize = val;
                this.getList()
            },
            handleCurrentChange(val) {
                this.formInline.currentPage = val;
                this.getList()
            },
            handleAdd(){
                this.dialogFormVisible=true;
                this.form={
                    "group_id": "",
                    "group_name": "",
                    "sort":0,
                    "tag":[]
                }
                this.addOne()
            },
            addOne(){
                this.form.tag.push({
                    name:'',
                    sort:this.form.tag.length+1,
                    conditionType:1
                });
            },
            handleEdit(data){
                this.tagData=data
                this.dialogFormRuleGrouVisible=true
            },
            save(data){
                console.log(data);
                if(data.group_id===""&&data.group_name===""){
                    this.$message({
                        message:"请选择分组或填写分组名称",
                        type:'error'
                    });
                    return;
                }
                //保存标签
                saveTagItem({item:encodeURIComponent(JSON.stringify(data))}).then((res) => {
                    //console.log(res);
                    if(res.data.success){
                        this.$message({
                            message:res.data.message,
                            type:'success'
                        });
                        this.getList(this.currentPage, this.pageSize);
                        this.dialogFormVisible=false;
                    }else{
                        this.$message({
                            message:res.data.message,
                            type:'error'
                        });
                    }
                });
            },
            saveTagItemCondition(){
                saveTag(this.tagData).then((res) => {
                    if(res.data.success){
                        this.$message({
                            message:res.data.message,
                            type:'success'
                        });
                        this.getList(this.currentPage, this.pageSize);
                        this.dialogFormRuleGrouVisible=false;
                    }else{
                        this.$message({
                            message:res.data.message,
                            type:'error'
                        });
                    }
                });
            },
            handDelete(row){
                this.$confirm('删除'+row.name+', 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.loading = true;
                    deleteTag({tagId:row.wxContactTagId}).then((res) => {
                        this.loading = false;
                        if(res.data.success){
                            this.$message({
                                message:res.data.message,
                                type:'success'
                            });
                            this.getList(this.currentPage, this.pageSize);
                        }else{
                            this.$message({
                                message:res.data.message,
                                type:'error'
                            });
                        }
                    })
                });
            },
            returnHistory(){
                window.history.back()
            },
        }
    }

</script>



// WEBPACK FOOTER //
// src/views/distribution/tag.vue